import {JsonApiResponse} from '@tisa-group/cdk';
import {UmpireStage} from '@tisa-group/models';
import {StageService} from '@tisa-group/core';
import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {Observable, tap} from 'rxjs';
import {LoadStages} from '@store/stages/stages.actions';

export type StagesStateModel = JsonApiResponse<UmpireStage[]>;

@State<StagesStateModel>({
  name: 'stages',
  defaults: {
    data: [],
  },
})
@Injectable()
export class StagesState {
  @Action(LoadStages)
  loadStages(
    ctx: StateContext<StagesStateModel>,
  ): Observable<JsonApiResponse<UmpireStage[]>> | JsonApiResponse<UmpireStage[]> {
    if (ctx.getState().data.length > 0) {
      return ctx.getState();
    }

    return this.stageService
      .list({include: 'season,groups'})
      .pipe(tap(stages => ctx.setState(stages)));
  }

  static getCurrentStage(
    seasonId: string,
  ): (state: StagesStateModel) => UmpireStage | undefined {
    return createSelector([StagesState], state => {
      return state.data.find(stage => stage.season.id === seasonId);
    });
  }

  constructor(readonly stageService: StageService) {}
}
